module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAAXNSR0IArs4c6QAAAFRQTFRFAAAAQEBAVVVVUFBQTU1NVVVVVVVVVVVVU1NTUlJSVVVVVVVVU1NTVVVVVlZWVFRUVVVVVFRUVVVVVFRUVVVVVVVVVFRUVVVVVFRUVVVVVFRUVVVV5IKKEwAAABt0Uk5TAAgMEBQYMDM3Oz9LU1dfi5OXn6erz9ff4+vvdGx+hQAAAF5JREFUGNOdzzkOgDAMAMENN4T7Soz//0+KgEhBgdjG8rgy/M6KRokFxHfPvT8E0GJb8gDZulcKKGbwLYB1gyEQNG5O03mvrlUBzOT8mBAT1HWYEd19JyljKeX9oZ+dF+0HJRgdkEMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/email.png
// module id = KxQv
// module chunks = 28